export enum FilingStatus {
  Single = "Single",
  MFJ = "Married filing jointly",
  MFS = "Married filing separately",
  HOH = "Head of household",
  QW = "Qualifying widow(er)",
}
